import { getEditorialImgUrl } from '@utils/imageUtils';

import useChannelsQuery from './queryHooks/useChannelsQuery';
import useProvidersQueries from './queryHooks/useProvidersQueries';

export const useProviderNames = () => {
  const { data: { data: channels = [] } = {} } = useChannelsQuery(undefined, {
    refetchOnMount: false,
  });
  const { data: providers = [] } = useProvidersQueries();

  const getProviderImage = (identifier: string) => {
    if (isNaN(parseInt(identifier))) {
      const provider = providers.find(({ id }) => id === identifier);
      if (provider) return getEditorialImgUrl(provider.image, 'square', { width: 100 });
    }
    return channels.find(({ value: { id } }) => id === identifier)?.value.images.at(0)?.url;
  };

  const getProviderName = (identifier: string) =>
    (isNaN(parseInt(identifier))
      ? providers.find(({ id }) => id === identifier)?.name
      : channels.find(({ value: { id } }) => id === identifier)?.value.name) ?? identifier;

  const getProviderList = (identifiers: string[]) =>
    identifiers?.map(identifier => ({
      key: identifier,
      label:
        (isNaN(parseInt(identifier))
          ? providers.find(({ id }) => id === identifier)?.name
          : channels.find(({ value: { id } }) => id === identifier)?.value.name) ?? identifier,
    }));

  return { getProviderName, getProviderList, getProviderImage };
};
